import type { AirportFuelQuote, AirportServiceEventSnapshot, AirportServiceRecord, WorldData } from "../../../domain/types";
export type PlayerView = "overview" | "planning" | "timeline" | "airports" | "recovery" | "fleet" | "logs";

export type ScheduledFlightGroup = {
  id: string;
  flightNo: string;
  origin: string;
  destination: string;
  departureTimeLocal: string;
  serviceDaysLabel: string;
  priority: number;
  planIds: string[];
};

export const PLAYER_VIEWS: Array<{ id: PlayerView; label: string }> = [
  { id: "overview", label: "总览" },
  { id: "planning", label: "编组" },
  { id: "timeline", label: "时间轴" },
  { id: "airports", label: "机场" },
  { id: "recovery", label: "自定义" },
  { id: "fleet", label: "机队" },
  { id: "logs", label: "日志" }
];

export const OPS_DAY_END_MINUTE = 24 * 60;

export type AirportObservationRole = "origin" | "destination";
export type AirportFuelDataSource = "ops_config" | "service_record";

export type AirportDataObservation = {
  key: string;
  record: AirportServiceRecord;
  role: AirportObservationRole;
  airportCode: string;
  counterpartCode: string;
  fuelQuote: AirportServiceRecord["offer"]["fuelQuote"];
  status: AirportServiceRecord["summary"]["status"];
  passengers: number;
  cargoKg: number;
  delayMinutes: number;
  blockers: string[];
};

export type AirportDataSummary = {
  code: string;
  airport?: WorldData["airports"][number];
  observations: AirportDataObservation[];
  latest?: AirportDataObservation;
  latestOrigin?: AirportDataObservation;
  currentFuelQuote?: AirportFuelQuote;
  currentFuelSource?: AirportFuelDataSource;
  currentEventSnapshots: AirportServiceEventSnapshot[];
};

export function normalizePlayerView(value: string | null): PlayerView {
  if (value === "planning" || value === "timeline" || value === "airports" || value === "recovery" || value === "fleet" || value === "logs") {
    return value;
  }
  return "overview";
}
